import { AfterViewInit, ChangeDetectionStrategy, Component, inject, model } from "@angular/core";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "component-base-modal",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class BaseModalComponent implements AfterViewInit {
  protected readonly activeModal = inject(NgbActiveModal);
  readonly autoFocus = model<boolean>(true);

  ngAfterViewInit(): void {
    if (!this.autoFocus()) return;

    setTimeout(() => {
      // search for first input
      const focusedElement = document.querySelector(".modal-body input:not([disabled])");
      if (focusedElement) {
        (focusedElement as HTMLElement).focus();
      } else {
        // search for primary button (usually ok)
        const primaryButton = document.querySelector(".modal-footer button.btn-primary");
        if (primaryButton) {
          (primaryButton as HTMLElement).focus();
        }
      }
    }, 0);
  }
}
